import { Controller } from "@hotwired/stimulus"

// Cascata estabelecimento -> secretarias (bonificacao). Ao mudar o pai, repopula
// as opcoes do child e mostra/esconde a coluna. Dirige o widget pela API nativa do
// Tom Select (clearOptions/addOption/refreshOptions); fallback p/ <option> cru se
// nao houver widget.
export default class extends Controller {
  static targets = ["parent", "child", "column"]
  static values = { secretarias: Object }

  connect() {
    this._onParentChange = () => this.update()
    this.parentTarget.addEventListener("change", this._onParentChange)
    this.update()
  }

  disconnect() {
    if (this._onParentChange) {
      this.parentTarget.removeEventListener("change", this._onParentChange)
    }
  }

  update() {
    const secretarias = this.secretariasValue[this.parentTarget.value] || []
    const ts = this.childTarget.tomselect

    if (ts) {
      ts.clear(true)
      ts.clearOptions(() => false) // remove TODAS (o default mantem as selecionadas)
      ts.addOption({ value: "", text: "Todas" })
      secretarias.forEach((s) => ts.addOption({ value: String(s.id), text: s.nome }))
      ts.refreshOptions(false)
    } else {
      this.childTarget.innerHTML = '<option value="">Todas</option>'
      secretarias.forEach((s) => {
        const opt = document.createElement("option")
        opt.value = s.id
        opt.textContent = s.nome
        this.childTarget.appendChild(opt)
      })
    }

    this.columnTarget.style.display = secretarias.length > 0 ? "" : "none"
  }
}
